module.exports = __webpack_public_path__ + "assets/images/project/netherlands-desktop.jpg?v=137523f5";